export const get1inchSwapLink = (inputAddress: string, outputAddress: string) => {
  return process.env.REACT_APP_ONEINCH_SWAP_LINK + `${inputAddress}/${outputAddress}`
}
